/** Chosen settings, per user as `<prefix>:<cognito sub>`. Stands in for `GET/PATCH me/settings`. */
export const USER_SETTINGS_KEY_PREFIX = 'gr-user-settings-v1';

/**
 * The signed-in user's notification rows. Other people's rows are seed data held in memory; only the
 * current user's survive a reload, which is all a browser can honestly persist.
 */
export const NOTIFICATION_PREFERENCES_KEY_PREFIX = 'gr-notification-preferences-v1';

/** Read state for the in-app notification centre. */
export const INBOX_READ_KEY_PREFIX = 'gr-inbox-read-v1';

export const PAGE_SIZE_OPTIONS: ReadonlyArray<number> = [10, 25, 50];

/**
 * The property's alert floor on the five-point scale. The legacy product alerts on a score of two or
 * lower and only support could move it; a person may raise their own threshold above this, never
 * below it.
 */
export const PROPERTY_ALERT_FLOOR = 2;

export const ALERT_THRESHOLD_MAX = 4;
